"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _domReadyPromise = require("./domReadyPromise");
Object.keys(_domReadyPromise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _domReadyPromise[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _domReadyPromise[key];
    }
  });
});